export default function VerificationFailedModal(props) {

    function logIn(e) {
        window.location.search = ''
    }

    return (
        <div className="Dimmer">
            <div className="FullPadding">
            <div className="ContentBox HalfPadding PopUp">
                <div style={{ textAlign: 'center' }}>
                    <p className="Message">The verification code you used is no longer valid.  Please try to log in again or create a new account.</p>
                    <div>
                        <button onClick={logIn}>Log In</button>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}
